import { useCallback, useContext, useEffect, useState } from "react";
import { formatCurrency } from "../../include/money";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";

import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../../components/CommanComponents/GradientLoader";
import { DataContext } from "../../context/DataContext";


function DashboardReport() 
{
    const navigate = useNavigate();

    const {loginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id;

    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false);

    const [datar, setDatar] = useState({
        total_generate_point: 0,
        total_redeem_point: 0,
        total_new_customer: 0,
        total_retain_customer: 0,
        total_sale_amount: 0,
        total_customer: 0,
    });
    
    /* -------------------- Utils -------------------- */
    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };
    
    /* -------------------- API -------------------- */
    const dashboardApi = useCallback(async (start, end) =>
    {
        if (!store_id) return;
        try 
        {
            setLoading(true); 
            const payload = { mod: "CASHI_LOYALTY_DASHBOARD", data_arr: { store_id, startDate: start, endDate: end },};
            const apiResult = await callPostApi("cashi-dashboard", payload);
            if (apiResult.status === "200" && apiResult.data) 
            {
                const item = apiResult.data;

                setDatar({
                    total_generate_point  : item.total_generate_point  || 0,
                    total_redeem_point    : item.total_redeem_point    || 0,
                    total_new_customer    : item.total_new_customer    || 0,
                    total_retain_customer : item.total_retain_customer || 0,
                    total_sale_amount     : item.total_sale_amount     || 0,
                    total_customer        : item.total_customer        || 0,
                });
          }
        }
        catch (err) { console.error("Dashboard API error:", err);} 
        finally { setLoading(false); }  

    },[store_id]);

    /* -------------------- Initial Load -------------------- */
    useEffect(() => 
    {
        const today     = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1); // subtract one day :contentReference[oaicite:0]{index=0}
        
        const s = sessionStorage.getItem("startdate") || formatDate(yesterday);
        const e = sessionStorage.getItem("enddate")   || formatDate(today);

        sessionStorage.setItem("startdate", s);
        sessionStorage.setItem("enddate", e);

        setStartDate(s);
        setEndDate(e);

        dashboardApi(s, e);

    }, [dashboardApi]);

    /* -------------------- Handlers -------------------- */
    const handlesearch = () => {  dashboardApi(startdate, enddate); };

    const clearfilter = () => 
    {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const s = formatDate(yesterday);
        const e = formatDate(today);

        sessionStorage.setItem("startdate", s);
        sessionStorage.setItem("enddate", e);
        
        setStartDate(s);
        setEndDate(e);

        dashboardApi(s, e);
    };

    const handleStartDateChange = (e) => 
    {
        setStartDate(e.target.value);
        sessionStorage.setItem("startdate", e.target.value);        
    };

    // Handler for end date
    const handleEndDateChange = (e) => 
    {
        setEndDate(e.target.value);
        sessionStorage.setItem("enddate", e.target.value);
        
    };

     /* -------------------- Navigation -------------------- */
    const gotosalereport     = () => { navigate("/saleReport",     { state: { startdate, enddate, }, }); };
    const gotocustomerreport = () => { navigate("/customerReport", { state: { startdate, enddate, }, }); };
  
    /* -------------------- Cards -------------------- */
    const cards = [
        { id: "1", title: "Points rewarded", value: datar.total_generate_point },
        { id: "2", title: "Points exchanged", value: datar.total_redeem_point },
        { id: "3", title: "New users", value: datar.total_new_customer },
        { id: "4", title: "Users retained", value: datar.total_retain_customer },
        { id: "5", title: "Total sale", value: formatCurrency(datar.total_sale_amount), onClick: gotosalereport },
        { id: "6", title: "Total customers", value: datar.total_customer, onClick: gotocustomerreport },
    ];


  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Box sx={{ background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2, p: 1.5, mb: 2, display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
        <input type="date" value={startdate} onChange={handleStartDateChange} style={{ border: `1px solid ${consoleColors.line}`, borderRadius: 8, padding: "8px 10px", color: consoleColors.ink }} />
        <Typography sx={{ color: consoleColors.muted, fontSize: 13 }}>to</Typography>
        <input type="date" value={enddate} onChange={handleEndDateChange} style={{ border: `1px solid ${consoleColors.line}`, borderRadius: 8, padding: "8px 10px", color: consoleColors.ink }} />
        <Button variant="contained" sx={primaryButtonSx} onClick={() => handlesearch()}>Apply</Button>
        <Button sx={{ textTransform: "none", color: consoleColors.ink }} onClick={() => clearfilter()}>Clear</Button>
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(3, 1fr)" }, gap: 1.5 }}>
        {cards.map((card) => (
          <Box
            key={card.id}
            onClick={card.onClick}
            sx={{
              background: "#fff",
              border: `1px solid ${consoleColors.line}`,
              borderRadius: 2.5,
              p: 2,
              cursor: card.onClick ? "pointer" : "default",
              "&:hover": card.onClick ? { borderColor: "#cbd5e1", boxShadow: "0 8px 20px rgba(15,23,42,0.06)" } : undefined,
            }}
          >
            <Typography sx={{ fontSize: 24, fontWeight: 700, color: consoleColors.ink, lineHeight: 1 }}>{card.value}</Typography>
            <Typography sx={{ fontSize: 13, color: consoleColors.muted, mt: 0.6 }}>{card.title}</Typography>
          </Box>
        ))}
      </Box>
      {loading && <GradientLoader text="Loading" />}
    </Box>
  );
}

export default DashboardReport;
